"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _airbnbPropTypes = require("airbnb-prop-types");
var _avatar = _interopRequireDefault(require("../avatar/avatar.presenter"));
var _icon = _interopRequireDefault(require("../icon/icon.presenter"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var AvatarGroup = function AvatarGroup(_ref) {
  var avatars = _ref.avatars,
    commonSize = _ref.commonSize,
    numberToShow = _ref.numberToShow,
    spacing = _ref.spacing,
    commonShape = _ref.commonShape,
    uniqueID = _ref.uniqueID;
  var avatarsToShow = avatars.slice(0, numberToShow);
  return _react.default.createElement("div", {
    className: "avatarGroup",
    "data-testid": uniqueID
  }, avatarsToShow.map(function (avatarProps) {
    return _react.default.createElement("div", {
      style: {
        marginRight: "".concat(spacing < -1 * (commonSize - 5) ? -1 * (commonSize - 5) : spacing, "px")
      },
      key: avatarProps.uniqueID
    }, _react.default.createElement(_avatar.default, _extends({}, avatarProps, {
      size: commonSize,
      shape: commonShape
    })));
  }), avatars.length > avatarsToShow.length && avatarsToShow.length !== 0 && _react.default.createElement("div", {
    className: "moreIconsAvatar"
  }, _react.default.createElement(_avatar.default, {
    uniqueID: "showMoreAvatars",
    backgroundColor: "grey",
    size: commonSize,
    shape: commonShape
  }), _react.default.createElement(_icon.default, {
    name: "ellipsis-h"
  })));
};
AvatarGroup.propTypes = {
  avatars: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    photoUrl: _propTypes.string,
    userName: _propTypes.string,
    userInitials: _propTypes.string,
    backgroundColor: _propTypes.string,
    uniqueID: _propTypes.string.isRequired
  })),
  commonSize: _propTypes.number,
  commonShape: _propTypes.string,
  numberToShow: (0, _airbnbPropTypes.and)([_propTypes.number, (0, _airbnbPropTypes.between)({
    gte: 1
  })]),
  spacing: _propTypes.number,
  uniqueID: _propTypes.string
};
AvatarGroup.defaultProps = {
  numberToShow: 3,
  commonSize: 40,
  spacing: 16,
  commonShape: 'circle'
};
var _default = AvatarGroup;
exports.default = _default;